import { Component, Prop, h, Host, Event, EventEmitter, Element, State, Method } from '@stencil/core';

@Component({
  tag: 'dda-input',
  styleUrls: [],
  shadow: false,
})
export class DdaInput {
  @Element() el: HTMLElement;

  @Prop() label: string;
  @Prop() placeholder: string;
  @Prop() value: string;
  @Prop() type: string = 'text';
  @Prop() input_role: string = 'text';
  @Prop() helper_text: string;
  @Prop() error_message: string;
  @Prop() validation_type?: string;
  @Prop() validation_id: string = 'text';
  @Prop() size?: string;
  @Prop() input_status?: string;
  @Prop() custom_class?: string;
  @Prop() component_mode?: string; 
  @Prop() input_id: string;
  @Prop() aria_label?: string;
  @Prop() input_name?: string;
  @Prop() required?: boolean = false;

  @State() internalValue: string = '';

  @Event() inputChanged: EventEmitter<any>;
  @Event() inputBlurred: EventEmitter<{ name: string; value: string }>;

  @Method()
  async getValue() {
    return this.internalValue || this.value || '';
  }

  componentDidLoad() {
    // Hide date input placeholder
    if (this.type === 'date') {
      const dateInput = this.el.querySelector('input[type="date"]') as HTMLInputElement;
      if (dateInput) {
        dateInput.style.color = 'transparent';
        dateInput.addEventListener('focus', () => {
          dateInput.style.color = '#000';
        });
        dateInput.addEventListener('blur', () => {
          if (!dateInput.value) {
            dateInput.style.color = 'transparent';
          }
        });
        dateInput.addEventListener('change', () => {
          dateInput.style.color = '#000';
        });
      }
    }
  }

  render() {
    const inputClass = [
      'dda-input-container',
      this.validation_type ? `dda-validation-${this.validation_type}` : '',
      this.size ? `dda-input-size-${this.size}` : '',
      this.input_status ? `dda-input-${this.input_status}` : '',
      this.type === 'Witherror' ? 'dda-validation-error' : '',
      this.type === 'disabled' ? 'dda-input-disabled' : '',
      this.custom_class,
      this.component_mode,
    ].filter(Boolean).join(' ');

    const describedByIds: string[] = [];
    if (this.helper_text) describedByIds.push(`${this.validation_id}-helper`);
    if (this.validation_type === 'error' && this.error_message)
      describedByIds.push(`${this.validation_id}-error`);

    return (
      <Host>
        <div class={inputClass}>
          {this.label && 
            <label 
              htmlFor={this.input_id} 
              class="dda-input-label"
              id={`${this.input_id}-label`}
            >
              {this.label}
            </label>}
          <input
            id={this.input_id}
            name={this.input_name}
            class={`dda-input-field dda-input-text ${this.type === 'date' && this.value ? 'has-value' : ''}`}
            type={this.type}
            role={this.input_role}
            placeholder={this.placeholder}
            value={this.internalValue || this.value}
            aria-required={this.required ? 'true' : undefined}
            aria-invalid={this.validation_type === 'error' ? 'true' : 'false'}
            aria-describedby={`${this.input_id}-label`}
            aria-label={!this.label ? this.aria_label : undefined}
            onInput={(event) => {
              this.internalValue = (event.target as HTMLInputElement).value;
              this.inputChanged.emit(event);
            }}
            onBlur={(event) => {
              const value = (event.target as HTMLInputElement).value.trim();
              this.inputBlurred.emit({ name: this.input_name, value });
            }}
          />

          {this.validation_type === 'error' && this.error_message ? (
            <span 
              class="dda-error-message" 
              id={this.validation_id}
              role="alert"
            >
              {this.error_message}
            </span>
          ) : (
            this.helper_text && (
              <span 
                class="dda-helper-text" 
                id={this.validation_id}
              >
                {this.helper_text}
              </span>
            )
          )}
        </div>
      </Host>
    );
  }
}
